import React from "react";
import { Upload, message, Button } from "antd";
import {
    LoadingOutlined,
    PlusOutlined,
    UploadOutlined,
    UserOutlined,
} from "@ant-design/icons";
import "./AdnAvatarUpload.css";
import ImgCrop from "antd-img-crop";

export const AdnAvatarUpload = ({ imageUrl, saveImage, loading, disabled }) => {
    function beforeUpload(file, fileList) {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            message.error("You can only upload JPG/PNG file!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error("Image must smaller than 2MB!");
        }
        if (isJpgOrPng && isLt2M) {
            saveImage(file);
            return true;
        }
        return false;
    }
    return (
        <div className="buttonAvatarWrapper">
            <ImgCrop grid rotate>
                <Upload
                    name="avatar"
                    listType="picture"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                >
                    <div className="uploaderButton">
                        {!disabled && (
                            <Button disabled={disabled} loading={loading} className="adn-outlined-button">
                                Upload Photo
                            </Button>
                        )}
                    </div>
                </Upload>
            </ImgCrop>
            {imageUrl ? (
                <img src={imageUrl} alt="avatar" className={"avatarUploaderAdn"} />
            ) : (
                <div className="avatarUploaderAdn">
                    <UserOutlined style={{ fontSize: "4.5rem", color: "white" }} />
                </div>
            )}
        </div>
    );
};

export default AdnAvatarUpload;
